import { Box } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid'

import { toFullTimezone } from '@rdm/common'

import { Tooltip } from '../../Tooltip'

export const renderFullTimezoneCell = (params: GridRenderCellParams) => {
  let text

  if (params.value === '-') {
    text = '-'
  } else {
    text = toFullTimezone(params.value)
  }

  return (
    <Tooltip title={text} placement="right">
      <Box sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{text}</Box>
    </Tooltip>
  )
}
